var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.871 10.853l-.749-.916a3.859 3.859 0 01-.865-2.413V5.826a4.23 4.23 0 00-3.312-4.128v-.8c0-.499-.4-.898-.9-.898-.499 0-.898.4-.898.899v.799a4.216 4.216 0 00-3.312 4.128v1.698c0 .882-.3 1.73-.866 2.413l-.749.916c-.516.632-.067 1.597.749 1.597h10.137c.832 0 1.281-.965.765-1.597zM8.117 16a2.16 2.16 0 002.164-2.164H5.953A2.16 2.16 0 008.117 16z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--bell-685780b91b2423bfe420602b62bfa095.svg";
export { SvgIconUiBell as Component };